import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  teamName: {
    name: "teamName",
    label: "Team Name",
    type: "text",
    errorMsg: "Team Name is required.",
    required: true,
    xs: 6,
    editable: false,
    maxLength: 100,
  },
  permission: {
    name: "permission",
    label: "Permission",
    type: "select",
    errorMsg: "Permission is required.",
    required: true,
    multiple: true,
  },
};

export const initialValues = getInitialValues(formField);

const { teamName, permission } = formField;

export const formRender = [[teamName], [permission]];

export const teamRoleValidation = Yup.object().shape({
  teamName: Yup.string().nullable().max(teamName.maxLength).required(teamName.errorMsg),
});
